var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.sortable ? "Draggable" : "div",
    _vm._g(
      _vm._b(
        {
          tag: "component",
          staticClass: "c-item-grid",
          class: _vm.wrapperClass,
          style: _vm.gridStyle,
        },
        "component",
        _vm.wrapperProps,
        false
      ),
      _vm.wrapperListeners
    ),
    _vm._l(_vm.items, function (item) {
      return _c(
        "GridItem",
        _vm._b(
          {
            key: item.id,
            attrs: { item: item, "is-selected": _vm.isSelected(item) },
            on: {
              click: function ($event) {
                return _vm.$emit("item-click", $event)
              },
              dblclick: function ($event) {
                return _vm.$emit("item-dblclick", $event)
              },
              "open-preview": function ($event) {
                return _vm.$emit("open-preview", $event)
              },
              download: function ($event) {
                return _vm.$emit("download", $event)
              },
              edit: function ($event) {
                return _vm.$emit("edit", $event)
              },
              "count-change": function ($event) {
                return _vm.$emit("item-count-change", { item, delta: $event })
              },
              "copy-to-file-browser": function ($event) {
                return _vm.$emit("copy-to-file-browser", $event)
              },
              action: function ($event) {
                return _vm.$emit("item-action", $event)
              },
              dragstart: function ($event) {
                return _vm.$emit("item-dragstart", { event: $event, item })
              },
              drop: function ($event) {
                $event.stopPropagation()
                return _vm.$emit("item-drop", { event: $event, item })
              },
            },
          },
          "GridItem",
          _vm.propsFor(item),
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }